import { Component } from 'react'

import store from 'shared/store'
import LastActivityService from 'views/assets/scripts/services/storage/LastActivityService'
import LastActivity from 'views/components/organisms/LastActivity'

class LastActivityContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      categories: [],
      products: [],
      topics: [],
    }
  }

  componentDidMount() {
    const { pageProperties } = store.getPublicRuntimeConfig()

    this.updateCategories(pageProperties)
    this.updateProducts(pageProperties)
    this.updateTopics(pageProperties)
  }

  updateCategories = pageProperties => {
    if (pageProperties?.categoryLastActivityProps) {
      LastActivityService.addCategory(pageProperties.categoryLastActivityProps)
    }

    this.setState({
      categories: LastActivityService.getCategories(),
    })
  }

  updateProducts = pageProperties => {
    if (pageProperties?.productLastActivityProps) {
      LastActivityService.addProduct(pageProperties.productLastActivityProps)
    }

    this.setState({
      products: LastActivityService.getProducts(),
    })
  }

  updateTopics = pageProperties => {
    if (pageProperties?.topicLastActivityProps) {
      LastActivityService.addTopic(pageProperties.topicLastActivityProps)
    }

    this.setState({
      topics: LastActivityService.getTopics(),
    })
  }

  render() {
    const { categories, products, topics } = this.state
    return <LastActivity {...{ categories, products, topics }} />
  }
}

export default LastActivityContainer
